// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select-wrapper {
  position: relative;
  width: 100%;
}

.custom-select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid var(--input-border);
  background-color: #ffffff;
  cursor: pointer;
  font-size: 16px;
  color: var(--text-primary);
  text-align: left;
  font-family: inherit;
  &:hover {
    border: 1px solid var(--border-primary-brand);
  }
}

.custom-select-trigger:focus {
  outline: none;
}

.custom-select-trigger.open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.custom-select-value {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.custom-select-arrow {
  flex-shrink: 0;
  margin-left: 8px;
  transition: transform 0.2s ease;
}

.custom-select-arrow.rotated {
  transform: rotate(180deg);
}

.custom-select-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  background-color: var(--surface-primary);
  border: 1px solid var(--color-brand);
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
}

.custom-select-option {
  padding: 8px 16px;
  font-size: 16px;
  color: #000000;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-select-option:hover {
  background-color: var(--color-brand-hover2);
}

.custom-select-option.selected {
  background-color: var(--color-brand-hover2);
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/CustomSelect/CustomSelect.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,wCAAwC;EACxC,oCAAoC;EACpC,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;AAClB","sourcesContent":[".custom-select-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.custom-select-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid var(--input-border);\n  background-color: #ffffff;\n  cursor: pointer;\n  font-size: 16px;\n  color: var(--text-primary);\n  text-align: left;\n  font-family: inherit;\n  &:hover {\n    border: 1px solid var(--border-primary-brand);\n  }\n}\n\n.custom-select-trigger:focus {\n  outline: none;\n}\n\n.custom-select-trigger.open {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.custom-select-value {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.custom-select-arrow {\n  flex-shrink: 0;\n  margin-left: 8px;\n  transition: transform 0.2s ease;\n}\n\n.custom-select-arrow.rotated {\n  transform: rotate(180deg);\n}\n\n.custom-select-options {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  background-color: var(--surface-primary);\n  border: 1px solid var(--color-brand);\n  border-top: none;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  max-height: 300px;\n  overflow-y: auto;\n  z-index: 1000;\n}\n\n.custom-select-option {\n  padding: 8px 16px;\n  font-size: 16px;\n  color: #000000;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.custom-select-option:hover {\n  background-color: var(--color-brand-hover2);\n}\n\n.custom-select-option.selected {\n  background-color: var(--color-brand-hover2);\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
